module.exports = __webpack_public_path__ + "img/index-ico5.72d92d2f.png";